module.exports = __webpack_public_path__ + "public/images/program/program-7.2389a3b93b36cd9704a6ca54dc2538d0.jpg";